<template>
  <div class="NextStepsPasswordReset text-center">
    <h1 class="font-family-display font-weight-bold mb-8">
      {{ $t('check_your_email') }}
    </h1>
    <p class="mb-24">
      {{ $t('please_check_email_for_recovery_link') }}
      <router-link :to="{ name: 'Login' }">
        {{ $t('back_to_login') }}
      </router-link>
    </p>
    <div class="NextStepsPasswordReset__inner">
      <img
        class="NextStepsOnboarding__img"
        src="/illustration_medidate.svg"
        alt="Illustration of person in a meditation position"
      />
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.NextStepsPasswordReset {
  padding: 0 rem(16);

  &__inner {
    max-width: rem(400);
    margin: 0 auto;
  }

  &__img {
    max-width: 100%;
  }
}
</style>
